/** Accesso al modulo Manutenzioni — attivato per struttura in Impostazioni. */

export function canAccessManutenzioni(user) {
  if (!user) return false;
  return Boolean(user.manutenzioni_enabled);
}

/** Gestione (stato, costi, fornitori, spese): Super Admin e Amministrativo. */
export function canManageManutenzioni(user) {
  if (!user) return false;
  const role = user.role;
  if (role === "super_admin" || role === "amministrativo") return true;
  if (role === "admin" || role === "Responsabile") return true;
  return false;
}
